<template>
	<div class="box-wrapper container">
		<template id="haveTitle" v-if="productsData.title">
			<div class="cont-box">
				<div class="top">
					<div class="classify-list wow slideInLeft" v-if="productsData.classifyName.length>0">
						<ul>
							<li v-for="item in productsData.classifyName"><a :href="'#'+item.id" id="">{{item.name}}</a></li>
						</ul>
					</div>
					<div class="box-introduce wow slideInRight">
						<img :src="productsData.bgImg" alt="" class="bg-img"/>
						<div class="cont">
							<h3 class="box-title">{{productsData.title}}</h3>
							<p class="text">
								{{productsData.info}}
							</p>
							<p class="img-box">
								<img :src="productsData.sbgImg" alt="" />
							</p>
						</div>
					</div>
				</div>
				<div class="content-box-wrapper">
					<div class="classify-box" v-for="item in productsData.list" :id="item.id">
						<h3 class="title wow slideInLeft" v-if="item.stitle" v-html="item.stitle">{{item.stitle}}</h3>
						<div class="product-list-box wow slideInUp" v-for="children in item.child">
							<div class="product-box" v-for="child in children">
								<div class="small-product" v-if="child.smallChild.length>0 && !child.isSmall" v-for="(sitem,index) in child.smallChild">
									<img :src="sitem.img" alt="" />
									<div class="float-detail" v-if="sitem.detail">
										<p>
											{{sitem.detail}}
										</p>
									</div>
									<p class="lineBg" v-if="index == 0"></p>
								</div>
								<div class="small-product" v-if="child.isSmall" style="display: flex;">
									<div class="small-box" v-for="(sitem,index) in child.smallChild" style="display: flex;">
										<img :src="sitem.img" alt="" />
										<div class="float-detail" v-if="sitem.detail">
											<p>
												{{sitem.detail}}
											</p>
										</div>
										<p class="YlineBg" v-if="index == 0"></p>
									</div>
									
								</div>
								<div class="normal" v-if="!child.smallChild && !child.isSmall">
									<img :src="child.img" alt="" />
									<div class="float-detail" v-if="child.detail">
										<p>
											{{child.detail}}
										</p>
									</div>
								</div>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template id="noTitle" v-if="!productsData.title">
			
		</template>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		props: ["products-data"]
	}
</script>

<style scoped="scoped">
	@import url("../../assets/css/animate.min.css");
	.cont-box{
		margin: 30px auto;
	}
	.cont-box .top{
		display: flex;
	}
	.cont-box .top .classify-list{
		width: 199px;
		flex: 0 0 199px;
		margin-right: 5px;
	}
	.cont-box .classify-list li{
		height: 35px;
		line-height: 35px;
		background: #979EA7;
		text-align: center;
		margin-bottom: 2px;
	}
	.cont-box .classify-list li:last-child{
		margin-bottom: 0;
	}
	.box-wrapper:nth-of-type(2) .cont-box .classify-list li{
		line-height: 72px;
		height: 72px;
	}
	.cont-box .classify-list li a{
		color: #fff;
		font-size: 16px;
		display: block;
	}
	.box-introduce{
		flex: 1;
		height: 100%;
		position: relative;
	}
	.box-introduce .bg-img{
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: 0;
	}
	.box-introduce .cont{
		position: relative;
		z-index: 5;
		margin-left: 10%;
		margin-bottom: 28px;
    	margin-top: 28px;
	}
	.box-introduce .cont .box-title{
		font-size: 24px;
		color: #fff;
		font-weight: bold;
	}
	.box-wrapper:first-child .box-introduce .cont .box-title{
		color: #FEBB3B;
	}
	.box-introduce .cont .text{
		color: #fff;
	    width: 287px;
    	line-height: 27px;
	}
	.box-introduce .cont .img-box{
		position: absolute;
		right: 40%;
		top: 50%;
		transform: translate(0, -50%);
		
	}
	.content-box-wrapper .classify-box{
		margin: 10px 0 30px 0;
	}
	.classify-box .title{
		font-size: 24px;
		color: #061F3E;
		margin-bottom: 20px;
	}
	.classify-box .title>span.small{
		font-size: 14px;
		color: #979EA7;
	}
	.classify-box .product-list-box{
		display: flex;
		margin-bottom: 15px;
	}
	.classify-box .product-box{
		margin-right: 15px;
		flex: 1;
		background: #fff;
		text-align: center;
		position: relative;
		cursor: pointer;
	} 
	.classify-box .product-box:last-child{
		margin-right: 0;
	}
	.classify-box .product-box .name{
		font-size: 16px;
		color: #666;
	}
	.classify-box .product-box .float-detail{
		position: absolute;
		top: 40%;
		left: 0;
		width: 100%;
		transform: translate(0, -50%);
		font-size: 12px;
		color: #fff;
		background: rgba(255, 102, 0, 0.84);
		padding: 10px;
		z-index: 5;
		display: none;
		
	}
	.classify-box .product-box>div{
		position: relative;
	}
	.classify-box .product-box>div:hover .float-detail{
		display: block;
	}
	.classify-box .float-detail p{
		margin-bottom: 0;
		line-height: 20px;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 5;
		overflow: hidden;
		display: -webkit-box;
		text-align: justify;
	}
	.classify-box .product-box img{
		width: 100%;
	}
	.lineBg{
		height: 20px;
		background: #F0F0F0;
	}
	.YlineBg{
		width: 20px;
		background: #F0F0F0;
		margin-bottom: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/device-small.vue